
  import Advertisement from "@/components/Advertisement";
  import ClientHead from "@/components/main/core/ClientHead";
  import RedSection from "@/components/main/core/RedSection";
  import RedHeadBox from "@/components/main/core/RedHeadBox";
  import CheckBox from "@/components/main/core/CheckBox";
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import BlogPost from "@/components/main/blog/BlogPost";
  import RedSearchNow from "@/components/main/core/RedSearchNow";
  import isMob576 from "@/mixins/isMob";

  import 'epic-spinners/dist/lib/epic-spinners.min.css'
  import {BreedingRhombusSpinner } from 'epic-spinners/dist/lib/epic-spinners.min.js'
  import Paginate from 'vuejs-paginate/src/components/Paginate.vue';
  const StarRating = process.client ? require('vue-star-rating').default : undefined

  export default {

    head() {
      const title = 'Blog ᐈ iFindCheaters';
      const description = 'Read online interesting and useful Articles about 【Adultery ❤️ Husband and Wife Relationships】in Blog ⏩ iFindCheaters ❤️ Find your cheating Spouse and Partner ⚡ Husband or Wife ⭐️ Anonymously ⚡ By email and name!';

      return {
        title: title,
        meta: [
            {
            hid: 'og:title',
            property: 'og:title',
            content: title
            },
          {
            hid: 'description',
            name: 'description',
             content: description
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: description
          },
          {
            hid: 'twitter:title',
            name: 'twitter:title',
            content: title
          }
        ],
        link: [
          {
            hid: "preload",
            rel: "preload",
            as: "image",
            href: require("@/assets/images/main/sample-report-bcg.webp"),
          },
          {
            hid: "canonical",
            rel: "canonical",
            href: this.$route.query.page === 1
              ? 'https://ifindcheaters.com/blog/'
              : `https://ifindcheaters.com/blog/?page=${this.$route.query.page}`,
          },
        ],
        script: [
          {
            type: 'application/ld+json',
            body: true,
            json: {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "iFindCheaters",
                "item": "https://ifindcheaters.com/"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "Blog",
              }],
            }
          }
        ]
      }
    },
    name: "index",
    layout: 'clientLayout',
    mixins: [isMob576],
    components: {Advertisement, ClientHead, RedSection, RedHeadBox, CheckBox, VueSlickCarousel, BlogPost, RedSearchNow, BreedingRhombusSpinner, Paginate, StarRating},

    async fetch() {
      const page = this.$route.query.page || 1;
      this.author = this.$route.params.slug;
      try {
        const [authorPostsResponse, authorInfoResponse, popularPostsResponse, tagsResponse, categoriesResponse] = await Promise.all([
          this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/authors/${this.author}/posts?page=${page}`),
          this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/authors/${this.author}`),
          this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/posts/popular`),
          this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/tags`),
          this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/categories`),
        ]);

        this.authorPostsData = authorPostsResponse.data;
        this.authorInfo = authorInfoResponse.data;
        this.popularPostsData = popularPostsResponse.data;
        this.tagsData = tagsResponse.data;
        this.categoriesData = categoriesResponse.data;
        this.socialNetworks = authorInfoResponse.data.data.socialNetworks;
      } catch (error) {
        console.error('Error:', error);
      }
    },
    data() {
      return {
        author: null,
        authorInfo: null,
        authorPostsData: null,
        popularPostsData: null,
        mainPostsData: null,
        tagsData: null,
        categoriesData: null,
        indexCanonical: 1,
        showMore: false,

        socialNetworks: {},

        socialNetworkMappings: {
          facebook: {
            class: 'fb',
            icon: ['fab', 'square-facebook']
          },
          instagram: {
            class: 'inst',
            icon: ['fab', 'square-instagram']
          },
          linkedin: {
            class: 'lnkdn',
            icon: ['fab', 'linkedin']
          },
          youtube: {
            class: 'you',
            icon: ['fab', 'square-youtube']
          },
          twitter: {
            class: 'tw',
            icon: ['fab', 'square-x-twitter']
          },
          pinterest: {
            class: 'pint',
            icon: ['fab', 'square-pinterest']
          },
          medium: {
            class: 'medm',
            icon: ['fab', 'medium']
          },
          reddit: {
            class: 'rddt',
            icon: ['fab', 'square-reddit']
          },
          qoura: {
            class: 'qra',
            icon: ['fab', 'qoura']
          },
          blogger: {
            class: 'blggr',
            icon: ['fab', 'blogger']
          }
        },
      }
    },

    methods: {
      getSocialNetworkUrl(name) {
        const network = this.authorInfo.data.socialNetworks.find(network => network.name === name);
        return network ? network.url : '';
      },
      getSocialNetworkClass(name) {
        return this.socialNetworkMappings[name] ? this.socialNetworkMappings[name].class : '';
      },
      getSocialNetworkIcon(name) {
        return this.socialNetworkMappings[name] ? this.socialNetworkMappings[name].icon : '';
      },
      pageChange(index) {
        let self = this
        this.$axios
          .get(`${process.env.BLOG_API_BASE_URL}/api/authors/${self.author}/posts?page=${index}`)
          .then(response => {
            self.authorPostsData = response.data
            self.indexCanonical = index
          })
        .catch(function (error) {
          console.log('error: ' + error);
        });
      },
      paginatePage(pageNum) {
        this.pageChange(pageNum)
        this.indexCanonical = pageNum
      },
      toggleShowMore() {
        this.showMore = !this.showMore;
      },
    },

    computed: {

      currentPage() {
        return this.$route.query.page ? parseInt(this.$route.query.page) : 1
      },

    },

  }
  